import BaseAPI from '../base'

function getPreorders() {
    return BaseAPI.sendGet(`queue/preorder/list`);
}

function acceptPreorder(id, waiting_time) {
    return BaseAPI.sendPost(`queue/preorder/accept`, {
        preorder_id: id,
        waiting_time
    });
}

function closePreorder(id) {
    return BaseAPI.sendPost(`queue/preorder/close`, {
        preorder_id: id
    });
}


function sendPreorder(id) {
    return BaseAPI.sendPost(`queue/preorder/send`, {
        preorder_id: id
    });
}


function cancelPreorder(id, reason) {
    return BaseAPI.sendPost(`queue/preorder/cancel`, {
        preorder_id: id,
        reason
    });
}

function orderCar(id, time) {
    return BaseAPI.sendPost(`queue/delivery/car`, {
        preorder_id: id,
        time
    });
}

function convertToInside(preorder_id, section, table) {
    return BaseAPI.sendPost(`queue/preorder/to_inside`, {
        preorder_id,
        section,
        table
    });
}

function createPreorder(data) {
    return BaseAPI.sendPost(`queue/preorder/create`, data);
}

export default {
    getPreorders,
    acceptPreorder,
    closePreorder,
    orderCar,
    sendPreorder,
    cancelPreorder,
    convertToInside,
    createPreorder
}